import { totalModel } from './totalModel'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'

export function PageHeader() {
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = totalModel()

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '加盟商名称',
            fieldName: 'partnerName',
            span: 3,
        },
        // {
        //     type: SearchTypeEnum.RangePicker,
        //     fieldName: '',
        //     title: '出账时间',
        //     rangePickerFieldName: ['startTime', 'endTime'],
        //     placeholder: ['出账开始时间', '出账结束时间'],
        //     format: 'YYYY-MM-DD',
        //     span: 6,
        // },
    ]

    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
